import { GridColDef, GridRowSelectionModel } from "@mui/x-data-grid-pro";
import {
  CircularProgress,
  GKButton,
  GKClientDataGrid,
  GKSideModal,
  Grid2,
} from "components";
import { useMutation } from "hooks/useQueries";
import { useForm } from "react-hook-form";
import { useAppSelector } from "store/store";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";

interface Props {
  open: boolean;
  onClose: () => void;
  templateId?: string;
}

type FormValues = {
  clients: number[];
};

const SendEmailTemplate = ({ open, onClose, templateId }: Props) => {
  const { clientList } = useAppSelector((state) => state?.app);

  const form = useForm<FormValues>({
    defaultValues: {
      clients: [],
    },
  });

  const { mutate: handleSendEmail, isLoading } = useMutation({
    mutationKey: ["SEND_EMAIL_TEMPLATE"],
    mutationFn: (data: FormValues) =>
      axiosInstance.post(`/custom-email/`, {
        clients: data.clients,
        template: templateId || "",
      }),
    onSuccess: () => {
      onClose();
      form.reset();
    },
  });

  const onSubmit = (data: FormValues) => {
    handleSendEmail(data);
  };

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Client Name / Code", "name", 180, 1),
    },
    {
      ...extraColumnsField("Email", "email", 180, 1),
      valueGetter: (params) => params.row.email || "-",
    },
  ];

  return (
    <GKSideModal
      width="60%"
      open={open}
      setOpen={onClose}
      modalTitle="Send Email Template"
      footerButton={
        <Grid2 container justifyContent={"flex-end"}>
          <GKButton
            variant="contained"
            type="submit"
            disabled={isLoading || form.watch("clients").length === 0}
            form="send-email-template-form"
          >
            {isLoading ? <CircularProgress size={20} /> : "Send"}
          </GKButton>
        </Grid2>
      }
    >
      <Grid2 size={12}>
        <form
          id="send-email-template-form"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <GKClientDataGrid
            name="sendEmailTemplate"
            showHeaderGrid={false}
            columns={columns}
            rows={clientList || []}
            checkboxSelection
            onRowSelectionModelChange={(
              newSelection: GridRowSelectionModel,
            ) => {
              form.setValue("clients", newSelection as number[]);
            }}
          />
        </form>
      </Grid2>
    </GKSideModal>
  );
};

export default SendEmailTemplate;
